import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Sunrise, Mail, MapPin } from 'lucide-react';
import { trackContactClick, trackFooterClick, trackMenuClick } from '../utils/analytics';

const Footer = () => {
  const handleContactClick = () => {
    trackContactClick('email');
  };

  const handleFooterLinkClick = (linkName) => {
    trackFooterClick(linkName);
  };

  const handleFooterNavClick = (linkName) => {
    trackMenuClick(linkName, false);
  };
  return (
    <footer className="bg-amber-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <picture>
                <source srcSet="/logo-64.webp" type="image/webp" />
                <img 
                  src="/logo-64.png" 
                  alt="Sun-Spot Logo" 
                  className="w-10 h-10 rounded-lg object-cover"
                  width="40"
                  height="40"
                />
              </picture>
              <span className="text-3xl font-bold">Sun-Spot</span>
            </div>
            
            <p className="text-amber-100 text-lg leading-relaxed mb-6 max-w-md">
              La plateforme communautaire gratuite pour découvrir et partager vos spots panoramiques préférés. 
              Votre prochain instant magique vous attend juste à côté.
            </p>

            <div className="flex items-center space-x-2 text-amber-200 mb-6">
              <Heart className="w-5 h-5" />
              <span className="font-medium">Créé avec passion pour la communauté</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Liens rapides</h3>
            <ul className="space-y-3">
            {[
                { name: 'Accueil', href: '/' },
                { name: 'Le Concept', href: '/concept' },
                { name: 'Comment ça marche', href: '/comment-ca-marche' },
                { name: 'Pourquoi Sun-Spot', href: '/pourquoi-sun-spot' },
                { name: 'Philosophie gratuite', href: '/philosophie' },
                { name: 'FAQ', href: '/faq' }
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    onClick={() => handleFooterNavClick(link.name)}
                    className="text-amber-200 hover:text-white transition-colors duration-200 flex items-center"
                  >
                    <MapPin className="w-4 h-4 mr-2" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3 text-amber-200">
                <Mail className="w-5 h-5" />
                <a 
                  href="mailto:contact@sun-spot.app"
                  onClick={handleContactClick}
                  className="hover:text-white transition-colors duration-200 underline decoration-dotted"
                >
                  contact@sun-spot.app
                </a>
              </div>
              
              <div className="bg-amber-800 rounded-lg p-4 mt-6">
                <h4 className="font-semibold mb-2 text-amber-100">Site web</h4>
                <p className="text-amber-200">sun-spot.app</p>
                <p className="text-sm text-amber-300 mt-2">Application mobile bientôt disponible</p>
              </div>
            </div>
          </div>
        </div>

        {/* Philosophy Reminder */}
        <div className="border-t border-amber-800 mt-12 pt-8">
          <div className="bg-gradient-to-r from-amber-800 to-orange-800 rounded-xl p-6 mb-8">
            <h4 className="text-lg font-bold mb-3 text-center">Notre engagement</h4>
            <p className="text-amber-100 text-center leading-relaxed">
              Sun-Spot restera toujours <span className="font-bold text-white">100% gratuit</span> et accessible à tous. 
              Ce projet est né de la passion et continuera d'être guidé par l'esprit communautaire et le partage.
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-amber-800 pt-8 text-center">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-amber-300">
              © 2025 Sun-Spot. Tous droits réservés. Plateforme communautaire gratuite.
            </p>
            
            <div className="flex items-center space-x-6 text-sm text-amber-300">
              <button 
                onClick={() => handleFooterLinkClick('mentions_legales')}
                className="hover:text-white transition-colors duration-200"
              >
                Mentions légales
              </button>
              <button 
                onClick={() => handleFooterLinkClick('contact_footer')}
                className="hover:text-white transition-colors duration-200"
              >
                Contact
              </button>
              <button 
                onClick={() => handleFooterLinkClick('confidentialite')}
                className="hover:text-white transition-colors duration-200"
              >
                Confidentialité
              </button>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;